import { render, staticRenderFns } from "./purchaseReturnRecord.vue?vue&type=template&id=38d3cbe8&scoped=true"
import script from "./purchaseReturnRecord.vue?vue&type=script&lang=js"
export * from "./purchaseReturnRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d3cbe8",
  null
  
)

export default component.exports